import QuoteSection from "@/components/petTag/Quotes";
import PetShowcase from "@/components/petTag/PetShowcase";
import PetReviewSection from "@/components/petTag/review/Section";
import PetTagReunion from "@/components/petTag/Reunion";

import PetTagFeaturesCarousel from "@/components/petTag/FeaturesCarousel";
import dynamic from "next/dynamic";
import React, { useState } from "react";
import PetTagVideo from "@/components/petTag/Video";
import PetTagHowWorks from "@/components/petTag/HowWorks";
import ActiveTag from "@/components/petTag/ActiveTag";
import PetTagFaq from "@/components/petTag/Faq";
import NavBarWrapper from "@/components/layout/NavWrapper";
import FooterWithBanner from "@/components/petTag/FooterWithBanner";
import PetTagHero from "@/components/petTag/PetTagHero";
import PetTagEssential from "@/components/petTag/Essential";
import Image from "next/image";
import ChatButton from "@/components/actions/button/ChatButton";
import { messengerUrl } from "@/utils/constants/chat";
import PetTagModal from "@/components/petTag/modal/PetTagModal";
const ComboDealsCarousel = dynamic(
  () => import("@/components/petTag/comboDealsCarousel"),
  { ssr: false }
);

function PetTagPage() {
  const [isActive, setIsActive] = useState(false);

  function TagModalActive() {
    setIsActive(true);
  }

  return (
    <>
      <div className="overflow-x-hidden">
        <PetTagHero onClick={TagModalActive} />

        <section className="relative">
          <Image
            src="/assets/pet-tag/pin3.png"
            width={38}
            height={54}
            alt="pin"
            className=" hidden lg:block absolute left-[50%] -translate-x-[50%] -top-[30px]"
          />
          <PetTagEssential onClick={TagModalActive} />
        </section>

        <PetTagFeaturesCarousel />

        <PetTagVideo />

        <PetTagHowWorks />

        <QuoteSection />

        <PetTagReunion onClick={TagModalActive} />

        <ComboDealsCarousel />

        <ActiveTag />

        <PetShowcase onClick={TagModalActive} />

        <PetReviewSection />

        <PetTagFaq />
      </div>

      <PetTagModal isActive={isActive} closeModal={() => setIsActive(false)} />
    </>
  );
}

export default PetTagPage;

PetTagPage.getLayout = ({ children }) => {
  return (
    <div>
      <NavBarWrapper />
      {children}
      <FooterWithBanner />
      <a href={messengerUrl} target="_blank" rel="noreferrer">
        <ChatButton />
      </a>
    </div>
  );
};
